import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './js/Home';
import Chatbot from './js/Chatbot';
import SignIn from './js/SignIn';
import SignInAmplify from './js/SignInAmplify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PulseLoader from 'react-spinners/PulseLoader';
import { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';// Initialize Google Analytics
import { query } from 'firebase/firestore';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { getCurrentUser, signIn, fetchAuthSession} from 'aws-amplify/auth';
Amplify.configure(awsExports);
ReactGA.initialize('G-W6N86H74EH');

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const tag = queryParams.get('tag');
  const query = queryParams.get('query');
  const lang =  queryParams.get('lang');
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);  // Loading state
  
  //*********Google authentication*************** 
  // Check if the user is already signed in on page load
  useEffect(() => {
    const storedAccessToken = localStorage.getItem('accessToken');
    if (storedAccessToken) {
      setIsSignedIn(true);
      console.log("already sign in")
    }
    setIsLoading(false);  // Once the check is done, stop loading
  }, []);

  //Handle successful sign-in and store user details
  const handleSignIn = (response) => {
    if (response && response.access_token) {
      // Store the access token and profile in local storage 
      localStorage.setItem('accessToken', response.access_token);
      localStorage.setItem('userProfile', JSON.stringify(response.profile));
      setIsSignedIn(true);
    } else {
      setIsSignedIn(false);
    }
  };

  // //***************AWS amplify authentication************//
  // Check if the user is already signed in on page load
  // useEffect(() => {
  //   const checkSession = async () => {
  //     try {
  //       const session = await fetchAuthSession();
  //       if (session.tokens?.accessToken) {
  //         console.log("User already signed in");
  //         const user = await getCurrentUser();
  //         // localStorage.setItem("accessToken", session.tokens.accessToken);
  //         // localStorage.setItem("userProfile", JSON.stringify(user));
  //         sessionStorage.setItem("accessToken", session.tokens.accessToken);
  //         sessionStorage.setItem("userProfile", JSON.stringify(user));
  //         setIsSignedIn(true);
  //       }
  //     } catch (error) {
  //       console.log("No active session found:", error);
  //     }
  //     setIsLoading(false);
  //   };

  //   checkSession();
  // }, []);

  // const handleSignIn = (session, user) => {
  //   // localStorage.setItem("accessToken", session.tokens.accessToken);
  //   // localStorage.setItem("userProfile", JSON.stringify(user));
  //   sessionStorage.setItem("accessToken", session.tokens.accessToken);
  //   sessionStorage.setItem("userProfile", JSON.stringify(user));
  //   setIsSignedIn(true);
  // };

  if (isLoading) {
    return (
      <div className="loader-container">
        <PulseLoader size={8} color="#30c484" />
      </div>
    );
  }
  return (
    <div className="App">
      <main>
      <Chatbot 
              tag={tag} 
              query_para={query} 
              lang={lang} 
              /> 
      {/* <GoogleOAuthProvider clientId='898015710493-a8gpr84qjvbvbd0ru1gmvo69m3b78j8l.apps.googleusercontent.com'>
          {!isSignedIn ? (
            <SignIn onSignIn={handleSignIn} />
          ) : (
            <Chatbot 
              tag={tag} 
              query_para={query} 
              lang={lang} 
              />  
          )}
        </GoogleOAuthProvider>  */}
        {/* {!isSignedIn ? (
          <SignInAmplify onSignIn={handleSignIn} />
        ) : (
          <Chatbot tag={tag} query_para={query} lang={lang} />
        )} */}
      
    {/* <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chatbot" element={<Chatbot dir={dir} />} />
      </Routes>
    </Router> */}
      </main>
    </div>
    
  );
}

export default App;
